"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IoMiningIndustries = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
var IoMiningIndustries = (function (_super) {
    __extends(IoMiningIndustries, _super);
    function IoMiningIndustries() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.IO_MINING_INDUSTRIES,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.SPACE],
            cost: 41,
            metadata: {
                cardNumber: '092',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.titanium(2).megacredits(2); }).br;
                    b.vpText('1 VP per Jovian tag you have.');
                }),
                description: 'Increase your titanium production 2 steps and your M€ production 2 steps.',
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.jovians(1, 1),
            },
        }) || this;
    }
    IoMiningIndustries.prototype.getVictoryPoints = function (player) {
        return player.getTagCount(Tags_1.Tags.JOVIAN, false, false);
    };
    IoMiningIndustries.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.TITANIUM, 2);
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        return undefined;
    };
    return IoMiningIndustries;
}(Card_1.Card));
exports.IoMiningIndustries = IoMiningIndustries;
